import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Layout, theme, FloatButton } from 'antd'
import {
  QuestionCircleOutlined,
  UpOutlined,
} from '@ant-design/icons'

// 组件
import Header from './Header'
import Sidebar from './Sidebar'

const { Content } = Layout

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false)
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken()

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  return (
    <Layout className="min-h-screen">
      {/* 侧边栏 */}
      <Sidebar collapsed={collapsed} />
      
      <Layout>
        {/* 顶部导航栏 */}
        <Header 
          collapsed={collapsed}
          onToggleCollapsed={toggleCollapsed}
        />
        
        {/* 主要内容区 */}
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* 浮动按钮 */}
      <FloatButton.Group shape="circle" style={{ right: 24, bottom: 24 }}>
        <FloatButton
          icon={<QuestionCircleOutlined />}
          tooltip="帮助"
          onClick={() => window.open('/docs', '_blank')}
        />
        <FloatButton.BackTop
          icon={<UpOutlined />}
          tooltip="回到顶部"
          visibilityHeight={200}
        />
      </FloatButton.Group>
    </Layout>
  )
}

export default MainLayout